import { FULL_PERCENT } from '@hooks/constants';
import { useQuery } from '@hooks/reactQuery';

import { fetchConsistencyCheckBranches } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';

import { TCMBranches } from '@interfaces/cmModule/cmModule';
import { TConsistencyCheckBranchesFetchDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';
import { IProgressBranches } from '@interfaces/import/import';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_FETCH } from '@constants/queryKeys';

interface IUseConsistencyCheckFetchBranchesParams extends Omit<TConsistencyCheckBranchesFetchDTO, 'dumpId'> {
	progress?: IProgressBranches;
	progressId?: string;
}

const useQueryConsistencyCheckFetchBranches = (params: IUseConsistencyCheckFetchBranchesParams) => {
	const {
		page,
		pageSize,
		sortDirection,
		sortFieldName,
		searchValue,
		progressId,
		progress,
	} = params;

	const isFullProgress = progressId === progress?.id && progress?.percentsProgress === FULL_PERCENT;

	const dumpId = progress?.dumpId || null;

	const {
		data: branchData,
		isLoading: isLoadingBranchData,
		isFetching: isFetchingBranchData,
	} = useQuery<TCMBranches | undefined>({
		queryKey: [
			CONSISTENCY_FETCH,
			{
				pageSize,
				page,
				sortDirection,
				sortFieldName,
				searchValue,
				dumpId,
			},
			progressId,
		],
		queryFn: extractQueryParams(fetchConsistencyCheckBranches),
		enabled: [!!dumpId, !!pageSize, !!page, isFullProgress],
		...refetchOptions,
	});

	return {
		branchData: branchData?.items || [],
		countOfRecords: branchData?.count || 0,
		isLoadingBranchData: (isLoadingBranchData && !!branchData) || isFetchingBranchData,
	};
};

export default useQueryConsistencyCheckFetchBranches;
